<template>
    <div class="slide1-container">
      <img
        v-for="(img, index) in imageList"
        :key="index"
        :src="img"
        class="animated-item"
        :style="{ animationDelay: `${index * 1}s` }"
      />
    </div>
  </template>
  
  <script setup lang="ts">
  const imageList = [
    '/images/login/login_chatbubble-1.png',
    '/images/login/login_chatbubble-2.png',
    '/images/login/login_chatbubble-3.png',
  ];
  </script>
  
  <style scoped lang="scss">
  .slide1-container {
    max-width: 20rem;
    max-height: 100%;
    margin: 0 auto;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: 1.5rem;
    padding: 0 1rem;
    overflow: hidden;
  }
  
  .animated-item {
    width: 100%;
    opacity: 0;
    transform: translateY(40px);
    animation: riseUp 0.7s ease forwards;
  }
  
  @keyframes riseUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  </style>
  